
/**
* @memberof rmOBA
* @ngdoc service
* @name rmGetDataResource
* @param $q {service} promise service
* @param $http {service} angular http request promise service
* @description 
*   Gets Order lines from data sheets
*/

rmOBA.factory('rmResources',
    function ($q, $http, rmUtils) {
        return {
            /**
            * @memberof rmGetDataResource
            * @function getLocationFormData
            * @desc Retreive user-completed Location form data from local storage
            * @returns {array} array of completed location form objects
            */
            getLocationFormData: function() {
                return $http.get("data/locationForm.json").
                    success(function (data, status, headers, config) {
                        return data;
                    }).
                    error(function (data, status, headers, config) {
                        console.log("failed to retrieve locationForm data");
                    });
            },
            /**
            * @memberof rmGetDataResource
            * @function getOrderLinesData
            * @desc Retreive all orderlines data
            * @returns {array} array of order line objects
            */
            getOrderLinesData: function() {
                return $http.get("data/orderLines.json").
                    success(function (data, status, headers, config) {
                        angular.forEach(data, function(value) {

                            // camelCase the Field value so it can be used as an ID
                            var fieldName = rmUtils.camelize(value["Field"]);
                            // set this as a value in the model
                            value['FieldName'] = fieldName;                            
                        });
                        return data;
                    }).
                    error(function (data, status, headers, config) {
                        console.log("failed to retrieve orderLines data");
                    });
            },
            /**
            * @memberof rmGetDataResource
            * @function getClassesData
            * @desc Retreive all classes data
            * @returns {array} array of classes objects
            */
            getClassesData: function() {
                return $http.get("data/classes.json").
                    success(function (data, status, headers, config) {
                        return data;
                    }).
                    error(function (data, status, headers, config) {
                        console.log("failed to retrieve classes data");
                    });
            },
            /**
            * @memberof rmGetDataResource
            * @function getContainersData
            * @desc Retreive all containers data
            * @returns {array} array of containers objects
            */
            getContainersData: function() {
                return $http.get("data/containers.json").
                    success(function (data, status, headers, config) {
                        return data;
                    }).
                    error(function (data, status, headers, config) {
                        console.log("failed to retrieve containers data");
                    });
            },
            /**
            * @memberof rmGetDataResource
            * @function getCopyData
            * @desc Retreive all copy data
            * @returns {array} array of copy objects
            */
            getCopyData: function() {
                return $http.get("data/copy.json").
                    success(function (data, status, headers, config) {
                        return data;
                    }).
                    error(function (data, status, headers, config) {
                        console.log("failed to retrieve copy data");
                    });
            },
            /**
            * @memberof rmGetDataResource
            * @function getCountriesData
            * @desc Retreive all countries data
            * @returns {array} array of countries objects
            */ 
            getCountriesData: function() {
                return $http.get("data/countries.json").
                    success(function (data, status, headers, config) {
                        return data;
                    }).
                    error(function (data, status, headers, config) {
                        console.log("failed to retrieve countries data");
                    });
            },
            /**
            * @memberof rmGetDataResource
            * @function getFeesData
            * @desc Retreive all fees data
            * @returns {array} array of fees objects
            */ 
            getFeesData: function() {
                return $http.get("data/fees.json").
                    success(function (data, status, headers, config) {
                        return data;
                    }).
                    error(function (data, status, headers, config) {
                        console.log("failed to retrieve fees data");
                    });
            },
            /**
            * @memberof rmGetDataResource
            * @function getFormatsData
            * @desc Retreive all formats data
            * @returns {array} array of formats objects
            */ 
            getFormatsData: function() {
                return $http.get("data/formats.json").
                    success(function (data, status, headers, config) {
                        return data;
                    }).
                    error(function (data, status, headers, config) {
                        console.log("failed to retrieve formats data");
                    });
            },
            /**
            * @memberof rmGetDataResource
            * @function getServicesData
            * @desc Retreive all services data
            * @returns {array} array of services objects
            */ 
            getServicesData: function() {
                return $http.get("data/services.json").
                    success(function (data, status, headers, config) {
                        return data;
                    }).
                    error(function (data, status, headers, config) {
                        console.log("failed to retrieve services data");
                    });
            },
            /**
            * @memberof rmGetDataResource
            * @function getSortationData
            * @desc Retreive all sortation data
            * @returns {array} array of sortation objects
            */ 
            getSortationData: function() {
                return $http.get("data/sortation.json").
                    success(function (data, status, headers, config) {
                        return data;
                    }).
                    error(function (data, status, headers, config) {
                        console.log("failed to retrieve sortation data");
                    });
            },
            /**
            * @memberof rmGetDataResource
            * @function getAutoConfirmData
            * @desc Retreive all automation data
            * @returns {array} array of automation objects
            */ 
            getAutoConfirmData: function() {
                return $http.get("data/autoconfirm.json").
                    success(function (data, status, headers, config) {
                        return data;
                    }).
                    error(function (data, status, headers, config) {
                        console.log("failed to retrieve sortation data");
                    });
            },
            /**
            * @memberof rmGetDataResource
            * @function getAllLookups
            * @desc Retreive all data in one go
            * @returns {array} array of all data objects
            */ 
            getAllLookups: function() {
                var _this = this,
                    lookups = {};
                return $q.all([
                            _this.getLocationFormData(),
                            _this.getOrderLinesData(),
                            _this.getClassesData(),
                            _this.getContainersData(),
                            _this.getCopyData(),
                            _this.getCountriesData(),
                            _this.getFeesData(),
                            _this.getFormatsData(),
                            _this.getServicesData(),
                            _this.getSortationData(),
                            _this.getAutoConfirmData(),
                        ]).then(function(data) {
                            lookups.locations = data[0].data;
                            lookups.orderLines = data[1].data;
                            lookups.classes = data[2].data;
                            lookups.containers = data[3].data;
                            lookups.copy = data[4].data;
                            lookups.countries = data[5].data;
                            lookups.fees = data[6].data;
                            lookups.formats = data[7].data;
                            lookups.services = data[8].data;
                            lookups.sortation = data[9].data;
                            lookups.autoconfirm = data[10].data;
                            return lookups;
                        });
            }
        };
    });